import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=0b83a200&scoped=true&"
import script from "./Users.js?vue&type=script&lang=js&"
export * from "./Users.js?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=0b83a200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83a200",
  null
  
)

export default component.exports